import ca1stScience from "./ca1stScienceQuizContent";
import ca1stSocialStudies from "./ca1stSocialStudiesQuizContent";
import ca1stMath from "./ca1stMathQuizContent";
import ca1stOther from "./ca1stOtherQuizContent";

// 2nd Grade
import ca2ndScience from "./ca2ndScienceQuizContent";
import ca2ndSocialStudies from "./ca2ndSocialStudiesQuizContent";
import ca2ndMath from "./ca2ndMathQuizContent";
import ca2ndOther from "./ca2ndOtherQuizContent";

// 3rd Grade
import ca3rdScience from "./ca3rdScienceQuizContent";
import ca3rdSocialStudies from "./ca3rdSocialStudiesQuizContent";
import ca3rdMath from "./ca3rdMathQuizContent";
import ca3rdOther from "./ca3rdOtherQuizContent";

// 4th Grade
import ca4thScience from "./ca4thScienceQuizContent";
import ca4thSocialStudies from "./ca4thSocialStudiesQuizContent";
import ca4thMath from "./ca4thMathQuizContent";
import ca4thOther from "./ca4thOtherQuizContent";

// 5th Grade
import ca5thScience from "./ca5thScienceQuizContent";
import ca5thSocialStudies from "./ca5thSocialStudiesQuizContent";
import ca5thMath from "./ca5thMathQuizContent";
import ca5thOther from "./ca5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const catopicsMapBySubject = {
  // 1st Grade
  ca_1st_science: ca1stScience,
  ca_1st_socialstudies: ca1stSocialStudies,
  ca_1st_math: ca1stMath,
  ca_1st_other: ca1stOther,

  // 2nd Grade
  ca_2nd_science: ca2ndScience,
  ca_2nd_socialstudies: ca2ndSocialStudies,
  ca_2nd_math: ca2ndMath,
  ca_2nd_other: ca2ndOther,

  // 3rd Grade
  ca_3rd_science: ca3rdScience,
  ca_3rd_socialstudies: ca3rdSocialStudies,
  ca_3rd_math: ca3rdMath,
  ca_3rd_other: ca3rdOther,

  // 4th Grade
  ca_4th_science: ca4thScience,
  ca_4th_socialstudies: ca4thSocialStudies,
  ca_4th_math: ca4thMath,
  ca_4th_other: ca4thOther,

  // 5th Grade
  ca_5th_science: ca5thScience,
  ca_5th_socialstudies: ca5thSocialStudies,
  ca_5th_math: ca5thMath,
  ca_5th_other: ca5thOther,
  // ...add the rest
};
